export const isBlank = (v) => v == null || (typeof v === "string" && v.trim() === "");
export const hasAny = (...vals) => vals.some((v) => !isBlank(v));

export function buildPerfilForm(data = {}) {
    return {
        nombre: data.nombre || "",
        nombre2: data.nombre2 || "",
        apellidos: data.apellidos || "",
        nickname: data.nickname || "",
        email: data.email || "",
        foto: data.foto || "",
        telefono: data.telefono || "",
        direccion: data.direccion || "",
        provincia: data.provincia || "",
        pais: data.pais || "",
        codigoPostal: data.codigoPostal || "",
        tipoDocumento: data.tipoDocumento || "",
        numeroDocumento: data.numeroDocumento || "",
        fechaCaducidad: data.fechaCaducidad || "",
        imagenDocumento: data.imagenDocumento || "",
        imagenDocumentoEnlaces: data.imagenDocumentoEnlaces || [],
        tratamiento: data.tratamiento || "",
        tipoPersona: data.tipoPersona || "CLIENTE",
        comentarios: data.comentarios || "",
        contacto: data.contacto || "",
        emailContacto: data.emailContacto || "",
        telefonoContacto: data.telefonoContacto || "",

        licenciasArmas:
            data.licenciasArmas?.map((lic) => ({
                id: lic.id || null,
                tipo: lic.tipo || "",
                pais: lic.pais || "",
                fechaDeExpedicion: lic.fechaDeExpedicion || "",
                fechaValidez: lic.fechaValidez || "",
                fechaIndefinida: !!lic.fechaIndefinida,
            })) ?? [
                {
                    id: null,
                    tipo: "",
                    pais: "",
                    fechaDeExpedicion: "",
                    fechaValidez: "",
                    fechaIndefinida: false,
                },
            ],

        licenciaCaza_numero: data.licenciasCaza?.[0]?.numero || "",
        licenciaCaza_fechaDeExpedicion: data.licenciasCaza?.[0]?.fechaDeExpedicion || "",
        licenciaCaza_rutaDocumento: data.licenciasCaza?.[0]?.rutaDocumento || "",
        licenciaCaza_fechaCaducidad: data.licenciasCaza?.[0]?.fechaCaducidad || "",
        licenciaCaza_fechaIndefinida: data.licenciasCaza?.[0]?.fechaIndefinida || false,
        licenciaCaza_enlaces: data.licenciasCaza?.[0]?.enlaces || [],
        licenciaArmas_rutaDocumento: data.licenciaArmasRutaDocumento || "",
        licenciaArmas_enlaces: data.licenciaArmasEnlaces || [],

        seguro_fechaDeCaducidad: data.seguros?.[0]?.fechaDeCaducidad || "",
        seguro_rutaDocumento: data.seguros?.[0]?.rutaDocumento || "",
        seguro_enlaces: data.seguros?.[0]?.enlaces || [],

        alergenos: data.alergenos?.map((ale) => ale.id) ?? [],

        armas:
            data.armas?.map((arma) => ({
                id: arma.id ?? null,
                modelo: arma.modelo || "",
                marca: arma.marca || "",
                pais: arma.pais || "",
                numeroGuia: arma.numeroGuia || "",
                numeroSerie: arma.numeroSerie || "",
                calibre: arma.calibre || "",
                tipoArma: arma.tipoArma || "",
                proximaReparacion: arma.proximaReparacion || "",
                rutaDocumentoGuiaArma: arma.rutaDocumentoGuiaArma || "",
                enlaces: arma.enlaces || [],
            })) ?? [
                {
                    id: null,
                    modelo: "",
                    marca: "",
                    pais: "",
                    numeroGuia: "",
                    numeroSerie: "",
                    calibre: "",
                    tipoArma: "",
                    proximaReparacion: "",
                    rutaDocumentoGuiaArma: "",
                    enlaces: [],
                },
            ],
    };
}

export function updateArrayItem(list, index, patch) {
    const copy = [...(list || [])];
    copy[index] = { ...(copy[index] || {}), ...(patch || {}) };
    return copy;
}

export function removeArrayItem(list, index) {
    const copy = [...(list || [])];
    copy.splice(index, 1);
    return copy;
}
